import styled from '@emotion/styled';
import { ellipsis } from '../styleMixins';

const Ellipsis = styled('span')({ ...ellipsis });

export default Ellipsis;
